<template>
  <div id="circularG">
    <div id="circularG_1" class="circularG"></div>
    <div id="circularG_2" class="circularG"></div>
    <div id="circularG_3" class="circularG"></div>
    <div id="circularG_4" class="circularG"></div>
    <div id="circularG_5" class="circularG"></div>
    <div id="circularG_6" class="circularG"></div>
    <div id="circularG_7" class="circularG"></div>
    <div id="circularG_8" class="circularG"></div>
  </div>
</template>

<script>

export default {
  name: 'SearchLoading',
  data() {
    return {};
  },
};
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style scoped lang="scss">
#circularG{
  position: relative;
  width: 84px;
  height: 84px;
  margin: 80px auto;
}

.circularG{
  position:absolute;
  background-color:rgb(232,53,50);
  width:18px;
  height:18px;
  border-radius: 50%;
  animation-name:bounce_circularG;
  animation-duration:1.1s;
  animation-iteration-count:infinite;
  animation-direction:normal;
}

#circularG_1{
  left: 0;
  top: calc(50% - 9px);
  animation-delay:0.41s;
}

#circularG_2{
  left: 9px;
  top: 9px;
  animation-delay:0.55s;
}

#circularG_3{
  top: 0;
  left: calc(50% - 9px);
  animation-delay:0.69s;
}

#circularG_4{
  right:9px;
  top:9px;
  animation-delay:0.83s;
}

#circularG_5{
  right:0;
  top: calc(50% - 9px);
  animation-delay:0.97s;
}

#circularG_6{
  right: 9px;
  bottom: 9px;
  animation-delay:1.1s;
}

#circularG_7{
  left: calc(50% - 9px);
  bottom:0;
  animation-delay:1.24s;
}

#circularG_8{
  left: 9px;
  bottom: 9px;
  animation-delay:1.38s;
}

@keyframes bounce_circularG{
  0%{
    transform:scale(1);
    background-color: rgb(232,53,50);
  }

  100%{
    transform:scale(0.67);
    background-color: rgba(232,53,50, 0.2);
  }
}
</style>
